export default {"src":"/_next/static/media/cultural_festivals.ba47ee56.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};